import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';
const apiUrl = GlobalConstants.apiURL
@Injectable({
  providedIn: 'root'
})
export class PatientjourneyService {

  constructor(private http:HttpClient, private sharedapi:SharedService) { }

  getPatientjourneyList(pageno:number,limit:number,qString:string){
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'patient-journey/get-listing/'+limit+'/'+pageno+'?'+qString,{headers:webheader})
  }

  UpdateIpdpatientJourney(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.put(apiUrl+'save-single-patient-journey-data',data,{headers:webheader})
  }

  getPatienttracker(pageno:number,limit:number,qString:string){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'patient-journey/get-tracker/'+limit+'/'+pageno+'?'+qString,{headers:webheader})
  }

  getDischargedPatienttracker(pageno:number,limit:number,qString:string){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'patient-journey/get-discharged-tracker/'+limit+'/'+pageno+'?'+qString,{headers:webheader})
  }

  getTodayPatientjourneyList(qString:string) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'patient-journey/get-today-patient-journey?'+qString,{headers:webheader})
  }

  getPatientjourneyUpdateLogs(patientJourId:string) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'patient-journey/get-patient-journey-update-log?patient_journey_id='+patientJourId,{headers:webheader})
  }

  getCityWisePatientjourney() {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'patient-journey/get-city-wise-patient-journey',{headers:webheader})
  }
}
